var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelopeColored = props => {
  props = {
    ...props,
    style: {
      display: 'inline-block',
      width: '1em',
      height: '1em',
      maxWidth: '100%',
      maxHeight: '100%',
      fill: 'currentColor',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: 0,
      ...props.style
    }
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 138 142"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0099DC",
    d: "M1.787 55.329h135.382v84.655H1.787z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27C1E6",
    d: "M137.169 55.329H1.787L63.919 2.737C67.096 0 71.86 0 75.036 2.737l62.133 52.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A859A",
    d: "M1.787 55.329h135.382l-67.691 57.283z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M118.906 139.983H20.049c-.794 0-1.588-.782-1.588-1.564V12.708c0-.782.794-1.564 1.588-1.564h98.658c.794 0 1.589.782 1.589 1.564v125.711c.198.782-.596 1.564-1.39 1.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D2D3",
    d: "M18.461 135.487h101.865V59.434L79.601 91.302H59.354L18.461 59.434z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0DB1CD",
    d: "M137.169 139.983V55.329L69.478 97.754zm-135.382 0V55.329l67.691 42.425z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.478 97.753 67.691 42.23-52.208-52.005zm0 0-15.484-9.775-52.207 52.005z",
    fill: "#0A859A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M99.055 35.388H39.9c-1.191 0-2.184-1.019-2.184-2.037v-.611c0-1.222.993-2.24 2.184-2.24h59.354c1.19 0 2.183 1.018 2.183 2.24v.611c-.198 1.018-1.19 2.037-2.382 2.037zm0 11.988H39.9c-1.191 0-2.184-.978-2.184-2.15v-.587c0-1.173.993-2.151 2.184-2.151h59.354c1.19 0 2.183.978 2.183 2.15v.587c-.198 1.173-1.19 2.15-2.382 2.15zm0 11.987H39.9c-1.191 0-2.184-.977-2.184-2.15v-.587c0-1.173.993-2.15 2.184-2.15h59.354c1.19 0 2.183.977 2.183 2.15v.587c-.198 1.368-1.19 2.15-2.382 2.15zm0 11.988H39.9c-1.191 0-2.184-.978-2.184-2.15v-.587c0-1.173.993-2.15 2.184-2.15h59.354c1.19 0 2.183.977 2.183 2.15v.586c-.198 1.173-1.19 2.151-2.382 2.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27C1E6",
    d: "M137.169 139.983H1.787l62.132-52.591c3.177-2.737 7.94-2.737 11.117 0l62.133 52.591z"
  }))));
};
export default SvgEnvelopeColored;